/* eslint-disable */
import { AppointmentListAppointmentScheduling } from '../dto/appointment-list-appointment-scheduling';
import { AppointmentListDocument } from '../dto/appointment-list-document';

export interface AppointmentListResponseDto {
  start: Date;
  end: Date;
  schedule: AppointmentListAppointmentScheduling;
  name: string | null;
  title: string | null;
  durationInMinutes: number | null;
  zoomLinkUrl: string | null;
  description: string | null;
  status: string;
  billingType: string;
  price: number | null;
  stornoDocumentId: number | null;
  documents: AppointmentListDocument[] | null;
}

export const fixAppointmentListResponseDtoFromJson = (dto?: AppointmentListResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.start = dto.start && new Date(dto.start);
  dto.end = dto.end && new Date(dto.end);
};

export const fixAppointmentListResponseDtoToJson = (dto?: AppointmentListResponseDto | null): void => {
  if (!dto) {
    return;
  }
};
